/*global $:false */

import UserSettingM from '@cob/ui-genesis/model/cob.user-settings.js';

import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

// Model responsible for storing the columns visibility, size and order of search results
//TODO JF: Os erros neste model deviam publicar eventos para os presenters poderem fazer o hide loading
var SearchVisM = function(core, entityM, settingM) {
    var i,
        n,
        length,
        cachedSettingsModel;

    const entityId = entityM.getId();

    this._core = core;
    this._entityM = entityM;
    this._cachedSettingsModelKey = "temporary-settings-model:" + this._entityM._entityKey + ":" + entityId;

    this._viewId = (settingM != undefined ? settingM.getId() : -1);

    //we only want to use the settings cache while in the same definition
    var currentEntityId = core.getModels("currentEntityId");
    if (currentEntityId !== entityId) {
        //clear any existing caches for this definition
        core.removeModels(this._cachedSettingsModelKey);
        core.addModel("currentEntityId", entityId);

    } else if (core.getModels(this._cachedSettingsModelKey)) {
        cachedSettingsModel = core.getModels(this._cachedSettingsModelKey)[this._viewId];
    }

    if (cachedSettingsModel) {
        this._columns = SearchVisM._extendColumnInfo(entityM, cachedSettingsModel.getValue() || []);
        this._settingM = cachedSettingsModel;

    } else {
        if (settingM) {
            this._columns = SearchVisM._extendColumnInfo(entityM, settingM.getValue() || []);
        } else {
            const fields = entityM.getSearchableFields();
            this._columns = utils.clone(fields) || [];

            // Default sorting order
            length = this._columns.length;
            n = 0;

            for (i = 0; i < length; i++) {
                if (this._columns[i].visible) {
                    this._columns[i].order = n++;
                }
                // copy the formatters, so that they keep the original scope (from before beeing cloned)
                if (this._columns[i].formatter) {
                    this._columns[i].formatter = fields[i].formatter;
                }
            }
        }
        this._settingM = settingM || new UserSettingM(core, entityM.getSettingKey(), "views");
    }

};

// It will add the other info from the entity columns that are not present
// in the visualization settings, like the formatters.
SearchVisM._extendColumnInfo = function(entityM, visualizationColumns) {
    return entityM.getSearchableFields().map(function(column) {

        var visColumn = visualizationColumns.filter(function(c) {
            return c.fieldName === column.fieldName;

        }).map(SearchVisM._filterColumn)
            .pop();

        if (!visColumn) {
            // If the column doesn't exist in list of columns for this visualization hide it
            visColumn = { visible: false };
        }

        return $.extend({}, column, visColumn);
    });
};

SearchVisM._filterColumn = function(column) {
    return {
        visible: column.visible,
        order: column.order,
        columnWidth: column.columnWidth,
        sorted: column.sorted,
        sortType: column.sortType
    };
};

SearchVisM.prototype._sortColumns = function(columns) {
    return columns.sort(function(a, b) {
        return a.order - b.order;
    });
};

SearchVisM.prototype.getVisibleColumns = function() {
    return this._sortColumns(this._columns.filter(function(col) {
        return col.visible;
    }));
};

SearchVisM.prototype.getVisibleColumnsNames = function() {
    return this.getVisibleColumns().map(function(column) {
        return column.fieldName;
    }).join(",");
};

SearchVisM.prototype.getVisibleColumnsNamesEscaped = function() {
    return this.getVisibleColumns().map(function(column) {
        return column.fieldName.replace(',','\\,');
    }).join(",");
};

SearchVisM.prototype.getVisibleColumnsLabels = function() {
    return this.getVisibleColumns().map(function(column) {
        return column.label;
    }).join(",");
};

SearchVisM.prototype.getVisibleColumnsLabelsEscaped = function() {
    return this.getVisibleColumns().map(function(column) {
        return column.label.replace(',','\\,');
    }).join(",");
};

SearchVisM.prototype.getColumns = function() {
    return this._columns;
};

// Return an object identifying the sorted column and the sort type
//
// `Properties` :
//   * `column`: the column identifier
//   * `sortType`: One of two values 'asc' or 'desc'
//
// `Ex`:
//  {
//    "column": <the column id>,
//    "sortType": ["asc"|"desc"]
//  }
SearchVisM.prototype.getSortedColumn = function() {
    var sortedColumn;

    this._columns.some(function(column) {
        if (column.sorted) {
            sortedColumn = {
                column: column.fieldName,
                ascending: (column.sortType === 'asc')
            };

            return true;
        }

        return false;
    });

    return sortedColumn;
};

SearchVisM.prototype.setColumns = function(columns) {
    this._columns = columns;
};

SearchVisM.prototype.setName = function(name) {
    this._settingM.setKey(name);
};

SearchVisM.prototype.getName = function() {
    return this._settingM.getKey();
};

SearchVisM.prototype.getId = function() {
    return this._settingM.getId();
};

SearchVisM.prototype.isSystemSetting = function() {
    return this._settingM.isSystemSetting();
};

SearchVisM.prototype.isOwnedByUser = function() {
    return this._settingM.isOwnedByUser();
};

SearchVisM.prototype.getOwner = function(){
    return this._settingM.getOwner();
};

SearchVisM.prototype.isShared = function() {
    return this._settingM.isShared();
};

SearchVisM.prototype.setShared = function(shared) {
    this._settingM.setShared(shared);
};

SearchVisM.prototype.setColumnVisibility = function(column, visibility) {
    var visibleLength = this.getVisibleColumns().length;

    this._columns.some(function(thisColumn) {
        if (thisColumn.fieldName === column.fieldName) {
            thisColumn.visible = visibility;

            if (thisColumn.order === undefined && visibility) {
                thisColumn.order = visibleLength;
            }

            return true;
        }

        return false;
    });
};

SearchVisM.prototype.setColumnWidth = function(columnName, width) {
    this._columns.some(function(column) {
        if (column.fieldName === columnName) {
            column.columnWidth = width;
            return true;
        }

        return false;
    });
};

SearchVisM.prototype.setColumnOrder = function(columns) {
    var i = 0,
        j = 0,
        inLength = columns.length,
        outLength = this._columns.length;

    for (i = 0; i < outLength; i++) {
        for (j = 0; j < inLength; j++) {
            if (this._columns[i].fieldName === columns[j].fieldName) {
                this._columns[i].order = j;
            }
        }
    }
};

SearchVisM.prototype.setSortedColumn = function(columnName, ascending) {
    this._columns.forEach(function(column) {
        if (column.fieldName === columnName) {
            column.sorted = true;
            column.sortType = ascending ? 'asc' : 'desc';

        } else if (column.sorted) {
            delete column.sorted;
            delete column.sortType;
        }
    });
};

SearchVisM.prototype.save = function(successFn) {
    this._settingM.setValue(
        SearchVisM._extendColumnInfo(this._entityM, this._columns)
    );

    this._settingM.save({
        success: successFn,
        error: function() {
            ui.notification.showError("An error occurred saving the view");
        }
    });
};

SearchVisM.prototype.share = function() {
    var _this = this;

    this._settingM.share({
        success: function(){
            _this._core.publish("recordm:settings:" + _this._entityM.getSettingKey() + ":view-shared", {
                viewId: _this._settingM.getId()
            });
        },
        error: function() {
            ui.notification.showError(_this._core.translateString("recordm.error.codes", "views.share"));
        }
    });
};

SearchVisM.prototype.unshare = function() {
    var _this = this;

    this._settingM.unshare({
        success: function(){
            _this._core.publish("recordm:settings:" + _this._entityM.getSettingKey() + ":view-unshared", {
                viewId: _this._settingM.getId()
            });
        },
        error: function() {
            ui.notification.showError(_this._core.translateString("recordm.error.codes", "views.unshare"));
        }
    });
};

SearchVisM.prototype.deleteSelf = function(successFn) {
    this._settingM.deleteSelf({
        success: successFn,
        error: function() {
            ui.notification.showError("An error occurred deleting the view");
        }
    });
};

// Creates a copy of the visualisation. It's used to allow free edit of a visualization while still keeping the
// original safe and keeping the settingM id handy in case of deletion/edit
SearchVisM.prototype.getCopy = function() {
    var copy = new SearchVisM(this._core, this._entityM);

    copy._settingM.setId(this._settingM.getId());
    copy._settingM.setValue(this._settingM.getValue());
    copy._settingM._isShared = this._settingM.isShared();

    copy.setName(this.getName());
    const cloned = utils.clone(this._columns);
    // we reset the formatters, so that they don't loose scope
    cloned.forEach((clone, idx) => clone.formatter = this._columns[idx].formatter);
    copy.setColumns(cloned);
    copy._viewId = (this._settingM.getId() || -1);

    return copy;
};


SearchVisM.prototype.updateTemporarySettingsCache = function() {
    var cache = this._core.getModels(this._cachedSettingsModelKey) || {};

    this._settingM.setValue(
        SearchVisM._extendColumnInfo(this._entityM, this._columns)
    );

    cache[this._viewId] = this._settingM;
    this._core.addModel(this._cachedSettingsModelKey, cache);
};

SearchVisM.prototype.clearTemporarySettingsCache = function() {
     this._core.removeModels(this._cachedSettingsModelKey);
};

SearchVisM.prototype.cacheOriginalSettings = function() {
    //keep original settings to reset them if needed (and without having to reload from db)
    var cache = this._core.getModels(this._cachedSettingsModelKey) || {};

    cache[this._viewId + "_original"] = this._settingM;
    this._core.addModel(this._cachedSettingsModelKey, cache);
};

SearchVisM.prototype.resetTemporarySettingsToOriginal = function() {
    //put the settings as they were originally
    var cache = this._core.getModels(this._cachedSettingsModelKey) || {};
    if (cache[this._viewId + "_original"]) {
        this._settingM = cache[this._viewId + "_original"];
        this._columns = SearchVisM._extendColumnInfo(this._entityM, this._settingM.getValue() || []);
    }

    //clear the full cache so there no loose ends :)
    this.clearTemporarySettingsCache();

    //reCache the original
    this.cacheOriginalSettings();
};

SearchVisM.prototype.hasTemporarySettingsCached = function() {
    var cache = this._core.getModels(this._cachedSettingsModelKey);

    return cache && cache[this._viewId] != undefined;
};

SearchVisM.prototype.hasOriginalSettingsCached = function() {
    var cache = this._core.getModels(this._cachedSettingsModelKey);

    return cache && cache[this._viewId + "_original"] != undefined;
};

export default SearchVisM;
